//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import complaintDrawer from "./modules/complaintDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { querySiteTree, queryUserTreeList as _queryUserTreeList } from '@/api/api'; // import JobOrderDrawer from './modules/JobOrderDrawer'
// import pipeNetwork from '@comp/page/pipeNetwork'

export default {
  name: 'FeedBackList',
  mixins: [JeecgListMixin],
  components: {
    complaintDrawer: complaintDrawer,
    querySiteTree: querySiteTree // JobOrderDrawer,
    // pipeNetwork

  },
  data: function data() {
    return {
      pagePath: '/om/complaints/back',
      pageTitle: '投诉单',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      siteName: '',
      userTree: [],
      siteTree: [],
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'operationType_dictText',
        colName: 'operationType_dictText',
        title: '设施类型',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'siteName',
        colName: 'siteName',
        title: '设施',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'complaintsDate',
        colName: 'complaints_date',
        title: '投诉日期',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'endTime',
        colName: 'end_time',
        title: '截止时间',
        align: 'center',
        sorter: true
      }, // {
      //   dataIndex: 'createBy_userName',
      //   colName: 'create_by',
      //   title: '反馈人',
      //   align: 'center'
      // },
      {
        dataIndex: 'tel',
        colName: 'tel',
        title: '联系电话',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'userId_userName',
        title: '处理人',
        align: 'center'
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '问题和意见',
        align: 'center'
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 200,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {
    /*currentSiteId(value) {
      var ids = this.getTreeCurrentId()
      this.queryParam.scopeId = ids[1]
      this.queryParam.scope = ids[0]
      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn)
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1)
      }
      this.delayLoadData()
    }*/
  },
  created: function created() {
    this.isorter = {
      column: 'complaints_date',
      order: 'asc'
    };
    this.queryUserTreeList();
  },
  computed: {},
  methods: {
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    siteSelect: function siteSelect(value) {
      console.log('siteSelect', value);
      this.queryParam.siteId = value;
      this.$forceUpdate();
    },
    selectOperation: function selectOperation(value) {
      console.log('value', value);
      this.queryParam.siteId = undefined;
      this.queryParam.operationType = value;
      this.$forceUpdate();

      if (value != 3) {
        if (value == 2) {
          this.getSiteTree(3);
          return;
        }

        this.getSiteTree(value);
      }
    },
    getSiteTree: function getSiteTree(addrType) {
      var _this2 = this;

      var param = {
        addrType: addrType
      };
      querySiteTree(param).then(function (res) {
        if (res.success) {
          _this2.siteTree = res.result;

          _this2.$forceUpdate();
        }
      });
    },
    // 1.站点 2.流域 3.管网  由于没有流域所以1.站点2.管网4.区域
    // 站点选择
    //  siteChange(data) {
    //    console.log('siteChange',data)
    //   /* sessionStorage.setItem('siteName', data.data.name == undefined ? data.data.title : data.data.name)
    //    sessionStorage.setItem('siteId', data.data.id)
    //    sessionStorage.setItem('operationType', data.data.id)*/
    //    this.queryParam.siteId = data.data.id
    //    this.queryParam.operationType = data.type
    // this.siteName = data.data.name == undefined ? data.data.title : data.data.name
    // this.operationType = data.type
    // this.siteId = data.data.id
    //    this.$refs.modalForm.model.siteName = data.data.name == undefined ? data.data.title : data.data.name
    //    this.$refs.modalForm.model.siteId = data.data.id
    //    this.$refs.modalForm.model.operationType = data.type
    //    this.loadData()
    //  },
    onDateFeedDate: function onDateFeedDate(value, dateArray) {
      this.queryParam.complaintsDateStart = dateArray[0];
      this.queryParam.complaintsDateEnd = dateArray[1];
    },
    addJob: function addJob(record) {
      var param = {
        originId: record.id,
        originKey: 'om_feed_back',
        siteId: record.siteId,
        siteName: record.siteName
      };
      this.$refs.jobForm.addJob = true;
      this.$refs.jobForm.showCheck = false;
      this.$refs.jobForm.disableSubmit = false;
      this.$refs.jobForm.edit(param);
    },
    handleCheck: function handleCheck(record, index) {
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showCheck = true;
      this.$refs.modalForm.edit(record);
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showCheck = false;
      this.$refs.modalForm.edit(record);
    },
    handleAdd: function handleAdd() {
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showCheck = false; // this.$refs.modalForm.operationType = this.operationType
      // this.$refs.modalForm.siteName = this.siteName
      // this.$refs.modalForm.siteId = this.siteId

      this.$refs.modalForm.add();
    },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.showCheck = false;
      this.$refs.modalForm.edit(record);
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        scopeId: this.queryParam.scopeId,
        scope: this.queryParam.scope,
        siteId: this.siteId,
        operationType: this.operationType
      };
      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = {
        scopeId: this.queryParam.scopeId,
        scope: this.queryParam.scope,
        siteId: this.siteId,
        operationType: this.operationType
      };
      this.dates = {};
      this.loadData(1);
    },
    // expandIcon属性 关联数据源展开按钮
    expandIcon: function expandIcon(props) {
      var h = this.$createElement;

      if (props.record.children) {
        if (props.record.children.length > 0) {
          if (props.expanded) {
            return h("a", {
              "style": "color: 'black',margin-right:0px",
              "on": {
                "click": function click(e) {
                  props.onExpand(props.record, e);
                }
              }
            }, [h("a-icon", {
              "attrs": {
                "type": "caret-down"
              }
            })]);
          } else {
            return h("a", {
              "style": "color: 'black' ,margin-right:0px",
              "on": {
                "click": function click(e) {
                  props.onExpand(props.record, e);
                }
              }
            }, [h("a-icon", {
              "style": "color:red",
              "attrs": {
                "type": "caret-right"
              }
            })]);
          }
        } else {
          return h("span", {
            "style": "margin-right:0px"
          });
        }
      }
    }
  }
};